export default __webpack_public_path__ + "static/media/Paws_up_email.f9f6f3af.jpg";